import { Subject } from 'rxjs'
import apiResponse from '../../../../../../services/apiResponse'
import UpdateRepository from '../Repositories/UpdateRepository'


class UpdateBloc {

    regionProvinceChannel = new Subject();
    regionCityChannel = new Subject();
    detailChannel = new Subject();
    updateChannel = new Subject();
    repository = new UpdateRepository()

    constructor() {
        this.updateChannel.next({status: apiResponse.INITIAL})
    }

    fetchRegionProvince = async (query) => {
        try {
            this.regionProvinceChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRegionProvince(query).then((result) => {
                this.regionProvinceChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.regionProvinceChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }

    fetchRegionCity = async (query) => {
        try {
            this.regionCityChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRegionCity(query).then((result) => {
                this.regionCityChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.regionCityChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }

    fetchUpdate = async (query) => {
        try {            
            this.updateChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchUpdate(query).then((result) => {
                this.updateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }
}

export default UpdateBloc